import { React, Component } from "react";
import { AppBar, Drawer, Typography, Toolbar, List, ListItem, ListItemText, IconButton, Divider } from "@material-ui/core";
import MenuIcon from '@material-ui/icons/Menu';
import { withStyles } from "@material-ui/styles";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";


const styles = {
  list: {
    width: 250,
  },
  root: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  }
}


class Header extends Component {

  state = {
    open: false,
  }



  handleToggle = (side, open) => (event) => {
    if (event.type === "keydown" && (event.key === 'Tab' || event.key === 'Shift'))
      return;
    this.setState({
      [side]: open,
    });
  }

  render() {
    const { classes } = this.props;

    const sideList = (
      <div className={classes.list}>
        <List>
          <Link to="/">
            <ListItem button>
              <ListItemText primary="Home"></ListItemText>
            </ListItem>
          </Link>

          <Divider />
          <Link to="/First">

            <ListItem button>
              <ListItemText primary="ヘルスチェック"></ListItemText>
            </ListItem>
          </Link>

          <Divider />
          <Link to="/Result">
            <ListItem button>
              <ListItemText primary="診断結果(オススメコンテンツ)"></ListItemText>
            </ListItem>
          </Link>
          <Divider />
          <Link to="/Second">
            <ListItem button>
              <ListItemText primary="気持ちのチェックリスト"></ListItemText>
            </ListItem>
          </Link>
          <Divider />
          <Link to="/Result2">
            <ListItem button>
              <ListItemText primary="診断結果(詳細)"></ListItemText>
            </ListItem>
          </Link>
        </List>
      </div>
    )
    return (
      <div className={classes.root}>
        <AppBar position="relative" color="inherit">
          <Toolbar>
            <IconButton className={classes.menuButton} aria-label="Menu" onClick={this.handleToggle("open", true)}>
              <MenuIcon />
            </IconButton>
            <Drawer open={this.state.open} onClose={this.handleToggle("open", true)}>
              <div
                tabIndex={0}
                role="button"
                onClick={this.handleToggle("open", false)}
                onKeyDown={this.handleToggle("open", false)}>
                {sideList}
              </div>
            </Drawer>
            <Typography type="title">
              メンタルヘルスチェック
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Header);
